import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot} from '@angular/router';
import { map } from 'rxjs';
import { UserAuthService }  from "../services/user-auth.service";

export const authTokenGuard = (next: ActivatedRouteSnapshot) => {
    const service = inject(UserAuthService);
  return service
    .isTokenValid()
    .pipe(
      map((isAuthorized) =>
        isAuthorized ? true : createUrlTreeFromSnapshot(next, ['/', 'cv-comp'])
      )
    );
};